export default __webpack_public_path__ + "static/media/multiple.54e79c34.svg";